import { render, staticRenderFns } from "./PreviouslyAdded.vue?vue&type=template&id=9c0bfdc8&scoped=true&"
import script from "./PreviouslyAdded.vue?vue&type=script&lang=js&"
export * from "./PreviouslyAdded.vue?vue&type=script&lang=js&"
import style0 from "./PreviouslyAdded.vue?vue&type=style&index=0&id=9c0bfdc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0bfdc8",
  null
  
)

export default component.exports